@tailwind base;
@tailwind components;
@tailwind utilities;

/* FullCalendar styles (ported from the Next.js calendar page's styled-jsx). */
.pomodoro-cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 0 4px;
}
.fc {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  font-size: 12px;
}
.fc-toolbar-title { font-size: 16px; }
.fc-event {
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  cursor: pointer;
  margin: 1px 0;
  padding: 1px 2px;
}
.fc-event-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.fc-timegrid-slot-label { font-size: 12px; }
.fc-col-header-cell { background-color: #fafafa; font-weight: 500; }
.fc-timegrid-axis { background-color: #fafafa; }
.fc-timegrid-slot { height: 40px; }
.fc-theme-standard .fc-scrollgrid,
.fc-theme-standard td,
.fc-theme-standard th { border: 1px solid #f0f0f0; }
.fc .fc-day-today { background-color: rgba(24, 144, 255, 0.05); }

/* /todo 的勾选圈：appearance:none + ::after 画对勾。写成 Tailwind 的 after:
   长串类会难以阅读，这一个自绘控件用 @apply（spec §6.3）。这不是开例外的
   口子——/todo 其余部分全部行内类。 */
.todo-check {
  @apply relative h-[17px] w-[17px] flex-none cursor-pointer appearance-none rounded-full border-[1.5px] border-todo-line2 bg-todo-card;
}
.todo-check:hover {
  @apply border-todo-accent;
}
.todo-check:checked {
  @apply border-todo-done bg-todo-done;
}
.todo-check:checked::after {
  content: '';
  @apply absolute left-[4px] top-[2px] h-[9px] w-[5px] rotate-45 border-b-[1.6px] border-r-[1.6px] border-solid border-white;
}

/* 详情栏步骤用的小一号 */
.todo-check-sm {
  @apply h-[14px] w-[14px];
}
.todo-check-sm:checked::after {
  @apply left-[3px] top-[1px] h-[7px] w-[4px];
}

/* 窄屏下把勾选圈的命中区撑到 44x44，视觉尺寸仍是 17px——17px 是设计稿定的，
   放大会破相，而且行高被撑开后一屏能看的任务数会下降。
   ::after 已经被 :checked 的对勾占用，所以用 ::before。
   顶边对齐到行的上内边距边缘（TaskRow 窄屏是 py-3 = 12px），向下取 44px：
   向上零溢出，不会盖住上一行；向下留在行内。 */
@media (max-width: 639px) {
  .todo-check::before {
    content: '';
    position: absolute;
    left: -13.5px;
    right: -13.5px;
    top: -12px;
    height: 44px;
  }
}
